import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MessageInput = ({ onSendMessage, disabled, suggestions }) => {
  const [message, setMessage] = useState('');
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef?.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef?.current?.scrollHeight, 120)}px`;
    }
  }, [message]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (message?.trim() && !disabled) {
      onSendMessage(message?.trim());
      setMessage('');
    }
  };

  const handleKeyDown = (e) => {
    if (e?.key === 'Enter' && !e?.shiftKey) {
      e?.preventDefault();
      handleSubmit(e);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    if (!disabled) {
      onSendMessage(suggestion);
    }
  };

  return (
    <div className="border-t border-border bg-card">
      {suggestions && suggestions?.length > 0 && (
        <div className="px-4 py-3 md:px-6 md:py-4 border-b border-border">
          <p className="text-xs md:text-sm text-muted-foreground mb-2 font-medium">
            Questions suggérées :
          </p>
          <div className="flex flex-wrap gap-2">
            {suggestions?.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => handleSuggestionClick(suggestion)}
                disabled={disabled}
                className="px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground text-xs md:text-sm transition-all border border-border hover:border-primary disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {suggestion}
              </button>
            ))}
          </div>
        </div>
      )}
      <form onSubmit={handleSubmit} className="px-4 py-3 md:px-6 md:py-4">
        <div className="flex items-end gap-2 md:gap-3">
          <div className="flex-1 relative">
            <textarea
              ref={textareaRef}
              value={message}
              onChange={(e) => setMessage(e?.target?.value)}
              onKeyDown={handleKeyDown}
              placeholder="Posez votre question sur l'orientation..."
              disabled={disabled}
              rows={1}
              className="w-full px-4 py-3 md:px-5 md:py-3.5 rounded-2xl bg-muted border border-border focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 text-sm md:text-base resize-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ minHeight: '48px', maxHeight: '120px' }}
            />
          </div>
          
          <Button
            type="submit"
            variant="default"
            size="icon"
            disabled={!message?.trim() || disabled}
            className="w-12 h-12 md:w-14 md:h-14 rounded-2xl flex-shrink-0"
          >
            <Icon name="Send" size={20} />
          </Button>
        </div>

        <p className="text-xs text-muted-foreground mt-2 px-1">
          Appuyez sur Entrée pour envoyer, Shift + Entrée pour une nouvelle ligne
        </p>
      </form>
    </div>
  );
};

export default MessageInput;